import { Link, useLocation } from 'react-router-dom';
import Header from '../header/HeaderComponent';
import Footer from '../footer/FooterComponent';
import Seo from '../Seo/SeoComponent';
import styles from '../../styles/authForm.module.scss';
import { useTranslation } from 'react-i18next';

export default function NotFoundPage() {
    const { pathname } = useLocation();
    const { i18n } = useTranslation();
    const isPt = pathname === '/pt' || pathname.startsWith('/pt/') || i18n.language === 'pt';
    const t = i18n.getFixedT(isPt ? 'pt' : 'en', 'common');
    return (
        <div className={styles.page}>
            <Seo title={t('notFound.seoTitle')} description={t('notFound.seoDescription')} path={pathname} noindex lang={isPt ? 'pt-PT' : undefined} />
            <Header />
            <main className={styles.main}>
                <section className={styles.container}>
                    <div className={styles.card}>
                        <h1 className={styles.title}>{t('notFound.title')}</h1>
                        <p className={styles.subtitle}>{t('notFound.message')}</p>
                        <Link to={isPt ? '/pt' : '/'} className={styles.link}>{t('notFound.goHome')}</Link>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
